let ipDirectSession = sessionStorage.getItem("ipredirect");

if (ipDirectSession != "Yonlendirildi") {
  sessionStorage.setItem("ipredirect", "Yonlendirildi");
  var data;
  var country;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer 0ca5fe2254ae34");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch("https://ipinfo.io", requestOptions)
    .then((response) => response.json())
    .then((data) => {
      obj = data;
    })
    .then((data) => {
      country = obj["country"];
    })
    .then(() => {
      if (country != "TR") {
        var url = window.location.href;
        var newurl = url.replace("houseofcaia.com", "thehouseofcaia.com");
        window.location.replace(newurl);
      }
    })
    .catch((error) => console.log("error", error));
}